export default __webpack_public_path__ + "static/media/delete-icon.846c102a.svg";